/**
 * Context that signals whether the current editor session is read-only.
 * When `readOnly` is true, mutation actions (move, resize, add, delete, paste, etc.)
 * are blocked at the UI level (toolbar, context menu, canvas drag, property panel).
 */
import { createContext, useContext } from "react";

const ReadOnlyContext = createContext<boolean>(false);

export const ReadOnlyProvider = ReadOnlyContext.Provider;

export function useEditorReadOnly(): boolean {
  return useContext(ReadOnlyContext);
}
